module.exports = __webpack_public_path__ + "static/img/program_09.4fa2e60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/program_09.jpg
// module id = j7RR
// module chunks = 0